import styled from 'styled-components';
import { tokens } from 'styles/tokens';

interface TitleProps {
	centralize?: boolean;
}

export const Container = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	padding: 20px;
	font-weight: 600;
	min-height: 128px;
	height: max-content;

	overflow: auto;
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

export const Title = styled.div<TitleProps>`
	padding-top: 17px;
	color: ${tokens.color_primary_lightest_title};
	text-align: ${({ centralize }) => centralize && 'center'};
`;
